import React from 'react';

import './styles.scss';

const AppPage: React.FC = ({ children }) => (
  <div className="page">{children}</div>
);

export default AppPage;
